import { useEffect, useState } from 'react';
// eslint-disable-next-line import/named
import 'react-toastify/dist/ReactToastify.css';
import { userResponseToUser } from '../services/helpers/UserMapper';
import { DefaultSpace, ServiceUser, SignUser, getUserById } from '../services/coworkerApiCalls/User/User';
import { User } from '../services/coworkerApiCalls/User/UsersTypes';
import { useOktaAuth } from '@okta/okta-react';

function useDataApi() {
    const [users, setUsers] = useState<User>();
    const { authState, } = useOktaAuth();

    const token = authState!.idToken!.idToken

    useEffect(() => {
        const getUsers = async () => {

            const userTemporary = await getUserById(token);
            const userResult: User = userResponseToUser(userTemporary);
            setUsers(userResult);

        };
        void getUsers();

    }, [token]); // Or [] if effect doesn't need props or state


    return users;
}

function useDataApiIsSigned(InIsSigned: boolean) {
    const [isSigned, setIsSigned] = useState<boolean>(InIsSigned);
    const { authState } = useOktaAuth();
    const token = authState!.idToken!.idToken
    useEffect(() => {
        const getUsers = async () => {

            const userTemporary = await getUserById(token);
            setIsSigned(userTemporary.isSigned);

        };
        void getUsers();

    }, [isSigned, token]); // Or [] if effect doesn't need props or state
    return isSigned;
}

async function getAPISign(token: string): Promise<boolean> {
    const userTemporary = await getUserById(token);
    return userTemporary.isSigned;
}

async function signCharterForUser(token: string): Promise<boolean> {

    await SignUser(token);

    const userTemporary = await getUserById(token);
    return userTemporary.isSigned;
}

async function defaultSpaceForUser(token: string, idDefaultSpace: number): Promise<boolean> {

    await DefaultSpace(token, idDefaultSpace);

    const userTemporary = await getUserById(token);
    return userTemporary.isSigned;
}

async function ServiceForUser(token: string, idDefaultSpace: number) {
    await ServiceUser(token, idDefaultSpace);
}
export { useDataApi, useDataApiIsSigned, signCharterForUser, getAPISign, defaultSpaceForUser, ServiceForUser }